define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PermitFeeRuleDomain = void 0;
    class PermitFeeRuleDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: PermitFeeRuleDomain.ApplyFee, value: "Apply Fee" },
                    { key: PermitFeeRuleDomain.WaiveFee, value: "Waive Fee" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[PermitFeeRuleDomain.ApplyFee] = 0;
                this.KeyIndex[PermitFeeRuleDomain.WaiveFee] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Apply Fee"] = 0;
                this.ValueIndex["Waive Fee"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.PermitFeeRuleDomain = PermitFeeRuleDomain;
    Object.defineProperty(PermitFeeRuleDomain, "ApplyFee", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(PermitFeeRuleDomain, "WaiveFee", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(PermitFeeRuleDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
